import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Megaphone, FileText } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { API_URL, fmtTime, fileUrl } from './chatShared';

// Avisos da Gestão por confirmar: aparecem numa janela até o comercial carregar em "Li e confirmo"
export const AnnouncementPopup = () => {
  const { user } = useAuth();
  const [list, setList] = useState([]);
  useEffect(() => {
    if (user?.role !== 'comercial') return undefined;
    const load = () => axios.get(`${API_URL}/chat/announcements/pending`).then((r) => setList(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    window.addEventListener('chat-ack', load);
    return () => { clearInterval(t); window.removeEventListener('chat-ack', load); };
  }, [user]);
  const cur = list[0];
  if (!cur) return null;
  const ack = async () => {
    try {
      await axios.post(`${API_URL}/chat/messages/${cur.id}/ack`);
      setList((l) => l.slice(1));
      window.dispatchEvent(new Event('chat-ack'));
    } catch { toast.error('Não foi possível confirmar. Tente de novo.'); }
  };
  return (
    <Dialog open onOpenChange={() => {}}>
      <DialogContent className="max-w-md [&>button]:hidden" data-testid="announcement-popup" aria-describedby={undefined}
        onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()}>
        <DialogHeader><DialogTitle className="flex items-center gap-2 text-amber-700"><Megaphone className="w-5 h-5" />Aviso da Gestão</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500">{cur.sender_name} · {fmtTime(cur.created_at)}{list.length > 1 ? ` · mais ${list.length - 1} por ler` : ''}</p>
        <p className="whitespace-pre-wrap text-sm text-slate-800 bg-amber-50 border border-amber-200 rounded-lg p-3 max-h-72 overflow-y-auto" data-testid="announcement-popup-text">{cur.text}
          {cur.file && <a href={fileUrl(cur.file.id)} target="_blank" rel="noreferrer" className="flex items-center gap-1 underline text-[#2D3E6F] mt-1" data-testid="announcement-popup-file"><FileText className="w-4 h-4" />{cur.file.name}</a>}</p>
        <DialogFooter>
          <Button onClick={ack} className="bg-emerald-600 hover:bg-emerald-700 w-full" data-testid="announcement-popup-ack">Li e confirmo</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
